module.exports = "<ng-content select=\"ic-card-menu-header\"></ng-content>\r\n<div class=\"ic-card__menu-body\">\r\n    <ng-content></ng-content>\r\n</div>\r\n<ng-content select=\"ic-card-menu-footer\"></ng-content>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/card/card-menu.component.html
// module id = ../../../../../src/app/layout/card/card-menu.component.html
// module chunks = main